<template>
    <span>
        <div class="vx-row ml-3 mt-8 mb-4">
            <div class="vx-col-w-full flex">
                <vs-checkbox color="primary" v-model="is_tab_expand" icon-pack="feather" icon="icon-check"
                    class="font-bold">Show tab titles</vs-checkbox>
            </div>
        </div>
        <div class="vx-row">
            <div class="w-full vx-col">
                <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs"
                    :key="isSmallerScreen" :value="active_step">

                    <vs-tab v-if="$canAny(['view-carriers-setting'])" icon-pack="feather" icon="icon-loader"
                        :label="is_expand ? 'Carriers' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <carrier-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-ccp-items-setting'])" icon-pack="feather" icon="icon-sliders"
                        :label="is_expand ? 'CCP Items' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <ccp-item-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-margin-costs-setting'])" icon-pack="feather" icon="icon-percent"
                        :label="is_expand ? 'Default Margin for Pricing' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <margin-list-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-formulation-compositions-setting'])" icon-pack="feather"
                        icon="icon-inbox" :label="is_expand ? 'Formulation Composition' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <formulation-composition-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-production-codes-setting', 'edit-production-codes-setting'])"
                        icon-pack="feather" icon="icon-target" :label="is_expand ? 'Production Codes' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <production-codes-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-raw-material-qc-test-setting'])" icon-pack="feather" icon="icon-filter"
                        :label="is_expand ? 'RM QC Tests' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <qc-test-settings />
                        </div>
                    </vs-tab>         
                    <vs-tab v-if="$canAny(['view-shipping-costs-setting'])" icon-pack="feather" icon="icon-truck"
                        :label="is_expand ? 'Shipping price for FGs' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <shipping-cost-list-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-sundry-costs-setting'])" icon-pack="feather" icon="icon-box"
                        :label="is_expand ? 'Sundry price for FGs' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <sundry-cost-list-settings />
                        </div>
                    </vs-tab>
                    <vs-tab icon-pack="feather" icon="icon-dollar-sign"
                        :label="is_expand ? 'Spray Dry Costing' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <spray-dry-cost-settings />
                        </div>
                    </vs-tab>
                    <vs-tab v-if="$canAny(['view-work-order-manufacturing-setting', 'edit-work-order-manufacturing-setting'])" icon-pack="feather" icon="icon-clock"
                        :label="is_expand ? 'Manufacturing Finance' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <manufacturing-finance-settings />
                        </div>
                    </vs-tab>

                </vs-tabs>
            </div>
        </div>
    </span>
</template>
<script>
import CcpItemSettings from "@/views/pages/settings/General/CcpItemSettings";
import MarginListSettings from './General/MarginListSettings.vue'
import ProductionCodesSettings from "@/views/pages/settings/General/ProductionCodesSettings";
import QcTestSettings from "@/views/pages/settings/General/QcTestSettings";
import CarrierSettings from './General/CarrierSettings'
import FormulationCompositionSettings from './General/FormulationCompositionSettings.vue'
import ShippingCostListSettings from './General/ShippingCostListSettings.vue'
import SundryCostListSettings from './General/SundryCostListSettings.vue'
import SprayDryCostSettings from "./General/SprayDryCostingSettings/SprayDryCostSettings.vue";
import ManufacturingFinanceSettings from './General/ManufacturingFinanceSettings.vue';
export default {
    name: 'ManufacturingSettings',
    data() {
        return {
            is_expand: true,
            tab_mapping: {
                'carriers': 0,
                'ccp_items': 1,
                'default_margin': 2,
                'formulation_composition': 3,
                'fg_product_form': 4,
                'qc_test': 5,
                'shipping_price': 6,
                'sundry_price': 7,
                'spray_dry': 8,
                'manufacturing_finance': 9,
            }
        }
    },
    components: {
        CcpItemSettings,
        MarginListSettings,
        ProductionCodesSettings,
        QcTestSettings,
        CarrierSettings,
        FormulationCompositionSettings,
        ShippingCostListSettings,
        SundryCostListSettings,
        SprayDryCostSettings,
        ManufacturingFinanceSettings
    },
    computed: {
        isSmallerScreen() {
            return this.$store.state.windowWidth < 768
        },
        is_tab_expand: {
            get() { return this.is_expand },
            set(val) { this.is_expand = val }
        },
        active_step() {
            const tabParam = this.$route.query.tab;
            if (!tabParam) return 0;
            const tabValues = tabParam.split(' ');
            for (const tab of tabValues) {
                if (this.tab_mapping[tab]) {
                    return this.tab_mapping[tab];
                }
            }
            return 0;
        }
    },
}
</script>
<style lang="">

</style>